import { duration } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { motion } from "framer-motion";
import Box from "../Box";
export const OverlayZoomContainer = motion.create(Box);
const overlayZoomTransition = (speed) => ({
    duration: duration.animation.moderate / 1000 / speed,
    ease: "backOut",
});
export const overlayZoomAnimation = {
    visible: (props) => ({
        opacity: 1,
        scale: 1,
        transition: overlayZoomTransition(props.speed),
    }),
    hidden: (props) => ({
        opacity: 0,
        scale: 0.9,
        transition: overlayZoomTransition(props.speed),
    }),
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiem9vbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL092ZXJsYXlBbmltYXRpb24vem9vbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQzFFLE9BQU8sRUFBRSxNQUFNLEVBQXdCLE1BQU0sZUFBZSxDQUFDO0FBQzdELE9BQU8sR0FBRyxNQUFNLFFBQVEsQ0FBQztBQUd6QixNQUFNLENBQUMsTUFBTSxvQkFBb0IsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0FBRXZELE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxLQUFhLEVBQWMsRUFBRSxDQUFDLENBQUM7SUFDNUQsUUFBUSxFQUFFLFFBQVEsQ0FBQyxTQUFTLENBQUMsUUFBUSxHQUFHLElBQUksR0FBRyxLQUFLO0lBQ3BELElBQUksRUFBRSxTQUFTO0NBQ2hCLENBQUMsQ0FBQztBQUVILE1BQU0sQ0FBQyxNQUFNLG9CQUFvQixHQUFhO0lBQzVDLE9BQU8sRUFBRSxDQUFDLEtBQW1CLEVBQUUsRUFBRSxDQUFDLENBQUM7UUFDakMsT0FBTyxFQUFFLENBQUM7UUFDVixLQUFLLEVBQUUsQ0FBQztRQUNSLFVBQVUsRUFBRSxxQkFBcUIsQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDO0tBQy9DLENBQUM7SUFDRixNQUFNLEVBQUUsQ0FBQyxLQUFtQixFQUFFLEVBQUUsQ0FBQyxDQUFDO1FBQ2hDLE9BQU8sRUFBRSxDQUFDO1FBQ1YsS0FBSyxFQUFFLEdBQUc7UUFDVixVQUFVLEVBQUUscUJBQXFCLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQztLQUMvQyxDQUFDO0NBQ0gsQ0FBQyJ9